import BaseService from './BaseService';
import { MedicationsResult } from '../models/medication';

export class MedicationService extends BaseService {
  getMedications = async (searchTerm: string, page: number, size: number): Promise<MedicationsResult> => {
    const query = this.BuildQueryString({ searchTerm: searchTerm || undefined, page, size });
    const result = await this.Fetch(`/medications?${query}`, 'GET');
    return this.FromResult<MedicationsResult>(result);
  };
}

export default MedicationService;
